import './hero-milestones-page.scss';
